import state from './moduleContaState'
import mutations from './moduleContaMutations'
import actions from './moduleContaActions'
import getters from './moduleContaGetters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
